
export function isSameDay(d1,d2){
  if (d1 === d2) {return true;}
  if (!d1 || !d2) {return false;}
  const d1s = d1.toString();
  const d2s = d2.toString();
  return  (d1s.substring(0,10) === d2s.substring(0,10));
}
